import loader from "assets/images/icons/loader.svg";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

const Loader = ({ className, hideText = false }) => {
  const { t } = useTranslation();
  return (
    <div
      className={classNames(
        className,
        "d-flex flex-column align-items-center justify-content-center"
      )}
    >
      <img src={loader} alt={"loader"} />
      {!hideText && (
        <div className="mt-4" style={{ color: "#b78925" }}>
          {t("Loading...")}
        </div>
      )}
    </div>
  );
};

export default Loader;
